<script lang="ts">
	import { onMount } from 'svelte';
	import Archive from '$lib/components/tours/Archive.svelte';
	import Seo from '$lib/components/SEO.svelte';
	import { browser } from '$app/environment';

	// Get tours from server-loaded data instead of importing from tours.js
	/** @type {import('./$types').PageData} */
	export let data;
	const { tours = [], toursByType = {}, metadata = {} } = data;

	// Make sure we have valid arrays for each category
	const validToursByType = {
		DAYTOUR: Array.isArray(toursByType.DAYTOUR) ? toursByType.DAYTOUR : [],
		MULTIDAYTOUR: Array.isArray(toursByType.MULTIDAYTOUR) ? toursByType.MULTIDAYTOUR : [],
		SHOREEXCURSION: Array.isArray(toursByType.SHOREEXCURSION) ? toursByType.SHOREEXCURSION : [],
		PRIVATETOUR: Array.isArray(toursByType.PRIVATETOUR) ? toursByType.PRIVATETOUR : []
	};

	console.log(
		`ToursPage: Received ${tours?.length || 0} tours and ${Object.keys(toursByType || {}).length} tour categories`
	);
	console.log(`ToursPage: Data source: ${metadata.source}, environment: ${metadata.environment}`);

	if (toursByType) {
		Object.entries(toursByType).forEach(([type, typeTours]) => {
			console.log(`ToursPage: ${type} has ${(typeTours as any[]).length} tours`);
		});
	}

	let animate = false;
	let isDataLoaded = browser ? tours && tours.length > 0 : true;

	onMount(() => {
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 200);
		animate = true;
		console.log(`ToursPage onMount: Tours count: ${tours?.length || 0}`);

		// Additional check to make sure data is loaded
		isDataLoaded = tours && tours.length > 0;

		// In case of browser rendering with no data, add additional debug info
		if (!isDataLoaded) {
			console.warn('Tours data not available in onMount, checking data object:', data);
		}
	});
</script>

<Seo
	title="Book Tasmania Tour Packages Today - Tassie Tours"
	description="Day tours from Hobart, Bruny Island Tours only $110, Cradle Mountain Tours only $150, Book your Tasmania Tours today!."
	keywords="Tasmania Tours, Tasmania local tour, Tassie Tours, Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours"
	siteName="Tassie Tours"
	imageURL="/images/hero-carousel-1.jpg"
	logo="/src/lib/assets/logo/logo-black.png"
	author="Tassie Tours"
	type="website"
	name="Tassie Tours"
	index={true}
	twitter={true}
	openGraph={true}
	schemaOrg={true}
	socials={[]}
/>
<main class="mx-auto max-w-7xl pt-12 lg:pt-24">
	<Archive />
</main>
